// extracted by mini-css-extract-plugin
export default {"button_area":"AllServiceStop_button_area__Pfg0w","footer":"AllServiceStop_footer__-cPqZ"};